import {createStore, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';

export const ActionTypes = {
    UPDATE_CONFIG: 'UPDATE_CONFIG',
    UPDATE_PAGE: 'UPDATE_PAGE',
    UPDATE_LOCATION: 'UPDATE_LOCATION',
    UPDATE_RESOURCES: 'UPDATE_RESOURCES',
    ADD_RESOURCES: 'ADD_RESOURCES',
    SET_AFFILIATE_ZIPCODE: 'SET_AFFILIATE_ZIPCODE',
};

const initialState = {
    affiliateZipcode: '94107',
    config: {},
    location: {},
    page: {},
    resources: {},
};

const reducer = (state, action) => {
    switch (action.type) {
        case ActionTypes.UPDATE_CONFIG: 
            return {...state, config: action.payload.config};

        case ActionTypes.UPDATE_PAGE:
            return {...state, page: action.payload.page};

        case ActionTypes.UPDATE_LOCATION:
            return {...state, location: action.payload.location};

        case ActionTypes.UPDATE_RESOURCES:
            return {...state, resources: action.payload.resources};

        case ActionTypes.ADD_RESOURCES:
            return {...state, resources: {...state.resources, ...action.payload.resources}};

        case ActionTypes.SET_AFFILIATE_ZIPCODE: 
            return {...state, affiliateZipcode: action.payload.affiliateZipcode}

        default:
            return state;
    }
};

export const makeStore = (initialStateParam) => {
    return createStore(reducer, initialStateParam, applyMiddleware(thunk));
};

export default function makeStoreWithContext () {
    return createStore(reducer, initialState, applyMiddleware(thunk));
}



// WEBPACK FOOTER //
// ./app/lib/redux/store.js